import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useDispatch } from 'react-redux'
import intl from 'react-intl-universal'
import { Popup, Tabs, Button, CenterPopup, ImageViewer } from 'antd-mobile'
import { useLocation } from 'react-router-dom'
import { useThrottleFn } from 'ahooks'
// import { debounce } from 'lodash'
import debounce from 'lodash/debounce';
import CurrencySymbol from '../../../components/CurrencySymbol'

import Header from '../../../components/Header'
import Article from '../../../components/Article'
import PopupContent from '../../../components/PopupContent'
import RelateAttrModal from '../../../components/ProductMenu/RelateAttrModal'

import BookForm from '../BookForm'

import defaultImg from '../../../assets/images/def_img_food.png'
import RelateTagList from '../../../components/RelateTagList'
import { scrollToElement } from '../../../utils/elementScroll'
import { resetCart } from '../../../store/reducers/cart'
import './index.less'
import PriceText from '../../../components/ProductMenu/PriceText'
import AttrString from '../../../components/ProductMenu/AttrString'

import NumStepper from '../../../components/NumStepper';
import CartIcon from '../../../components/Icon/CartIcon';
import math, { formatNumber } from '../../../utils/math'
import { replaceCDNDomain } from '../../../utils'
import { addBehaviorsRecord } from '../../../utils/BehaviorstatsHelp'


const tabHeight = 48 + 42
const ActivityDetail = ({ detail, callback, isReadOnly = false, merchantInfo }) => {
  const [bookFormVisible, setBookFormVisible] = useState(false)
  const [activeKey, setActiveKey] = useState('1')
  const [tabItems, setTabItems] = useState([])
  const [attrVisible, setAttrVisible] = useState(false)
  const [curProduct, setCurProduct] = useState(null)
  const [actionFlag, setActionFlag] = useState(1)
  const [detailFlag, setDetailFlag] = useState(false)
  const [cartItems, setCartItems] = useState([])

  const dispatch = useDispatch()
  const lastScrollYRef = useRef(window.scrollY)

  const { productName, images, description, price = 0, currency } = detail
  let { bookingInstructions, notes } = detail || {}

  const { storeInfo } = merchantInfo || {}
  if (!bookingInstructions) {
    bookingInstructions = storeInfo?.bookingInstructions
  }
  if (!notes) {
    notes = storeInfo?.notes
  }


  const renderTabItems = useCallback(() => {
    const tabItems = [
      {
        key: '1',
        title: intl.get('t_info').d('Info')
      }
    ]
    if (bookingInstructions) {
      tabItems.push({
        key: '2',
        title: intl.get('book_tips').d('预定须知')
      })
    }
    if (notes) {
      tabItems.push({
        key: '3',
        title: intl.get('notice_item').d('注意事项')
      })
    }
    setTabItems(tabItems)
  }, [bookingInstructions, notes]);

  const { run: handleScroll } = useThrottleFn(
    () => {

      let currentKey = tabItems[0]?.key
      for (const item of tabItems) {
        const element = document.getElementById(`act-dt-tab-${item.key}`)
        if (!element) continue
        const rect = element.getBoundingClientRect()
        if (rect.top <= tabHeight) {
          currentKey = item.key
        } else {
          break
        }
      }
      setActiveKey(currentKey)
    },
    {
      leading: true,
      trailing: true,
      wait: 100,
    }
  )

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  useEffect(() => {
    renderTabItems()
  }, [renderTabItems])

  useEffect(() => {
    setCartItems([])
    setCurProduct(null)
    console.log(cartItems, '////====cartItems===', detail.productId)
  }, [detail.productId])

  const location = useLocation()
  if (location.state && location.state.detail) {
    detail = location.state.detail
  }

  const totalQuantity = cartItems.reduce((sum, item) => math.add(sum, item.quantity || 1), 0);
  const totalPrice = cartItems.reduce((sum, item) => math.add(sum, item.amount), 0);

  const getTotalPrice = () => {
    const { attrArr = [], specItem } = curProduct
    const attrPrice = attrArr.length > 0 ? attrArr.reduce((sum, item) => math.add(sum, math.mul(item.price, item.quantity || 1)), 0) : 0
    const specPrice = specItem ? math.mul(specItem.price, 1) : curProduct.price
    const totalPrice = math.add(attrPrice, specPrice)
    return totalPrice || 0
  }

  // 获取商品价格
  const getProductPrice = (product) => {
    const { price, quantity = 1, attrArr = [], specItem } = product
    const attrPrice = attrArr.reduce((sum, item) =>
      math.add(sum, math.mul(item.price, item.quantity || 1)), 0)
    const specPrice = specItem ? math.mul(specItem.price, 1) : price
    return math.mul(math.add(attrPrice, specPrice), quantity)
  }

  // 更新购物车
  const updateCartItems = (newItems) => {
    setCartItems(newItems)
    // setShoppingCart(newItems, storeId)
  }

  // 添加到购物车
  const addToCart = (item, fromCart = false) => {
    setCartItems(prev => {
      const exists = prev.find(i =>
        i.productId === item.productId &&
        i.specsKey === item.specsKey &&
        i.attrKeys === item.attrKeys &&
        i.subAttrKeys === item.subAttrKeys
      )

      if (exists) {
        const newItems = prev.map(i => {
          if (i.productId === item.productId &&
            i.specsKey === item.specsKey &&
            i.attrKeys === item.attrKeys &&
            i.subAttrKeys === item.subAttrKeys) {
            const newItem = { ...i, quantity: fromCart ? math.add(i.quantity, 1) : math.add(i.quantity, item.quantity) }
            return { ...newItem, amount: getProductPrice(newItem) }
          }
          return { ...i, amount: getProductPrice(i) }
        })
        //updateCartItems(newItems)
        return newItems
      }

      const newItem = { ...item }
      const newItems = [...prev, { ...newItem, amount: getProductPrice(newItem) }]
      //updateCartItems(newItems)
      return newItems
    })
  }

  // 从购物车移除
  const removeFromCart = (itemId, value, pd) => {
    setCartItems(prev => {
      const newItems = prev.reduce((acc, item) => {
        if (item.productId === pd.productId &&
          item.specsKey === pd.specsKey &&
          item.attrKeys === pd.attrKeys &&
          item.subAttrKeys === pd.subAttrKeys) {
          if (item.quantity > 1) {
            const newItem = { ...item, quantity: item.quantity - 1 }
            return [...acc, { ...newItem, amount: getProductPrice(newItem) }]
          }
          return acc
        }
        return [...acc, { ...item, amount: getProductPrice(item) }]
      }, [])

      //updateCartItems(newItems)
      return newItems
    })
  }

  const calculatePageHeight = () => {
    const height = window.innerHeight
    console.log('resize', height, '=====////resize/////')
    document.querySelector('.act-detail-wrapper').style.height = height + 'px'
  }
  useEffect(() => {
    calculatePageHeight(); // 初始计算

    const handleResize = debounce(calculatePageHeight, 100);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const img = replaceCDNDomain(merchantInfo?.productImages) || defaultImg

  return (
    <div className='act-detail-wrapper' style={{ height: window.innerHeight, overflowY: 'auto', overflowX: 'hidden' }}>
      <Header title={productName || detail.name} callback={callback} />
      <div className='act-detail-main'>
        <div className='act-item'>
          <img
            src={replaceCDNDomain(images) || img}
            alt="product"
            onClick={() => {
              if (!images) return
              ImageViewer.show({
                image: replaceCDNDomain(images)
              })
            }}
            onError={(e) => { e.target.src = img }}
          />
          <div className='act-content'>
            <div className='jm-flex'>
              <div className='act-name jm-flex-item'><b>{productName || detail.name}</b></div>
            </div>

            <div>
              <RelateTagList list={detail.tagRelates} />
            </div>
            {/* <div className='act-info'>
              <div>{bookingInstructions}</div>
            </div> */}
            <div className='act-price' style={{ marginTop: 6 }}>
              <b className='jm-price fs-18'>
                <PriceText product={detail} />
              </b>
            </div>
          </div>
        </div>

        {
          (bookingInstructions || notes) ?
            <div className='tabs-container'>
              <Tabs
                activeKey={activeKey}
                onChange={key => {
                  const target = document.getElementsByClassName(`act-dt-tab-${key}`)[0]
                  scrollToElement({
                    target,
                    offset: 88,
                    gridHeight: 0,
                    lastScrollYRef: lastScrollYRef,
                    container: document.querySelector('.act-detail-wrapper')
                  })

                  setTimeout(() => {
                    setActiveKey(key)
                  }, 100)

                }}
              >
                {tabItems.map(item => (
                  <Tabs.Tab title={item.title} key={item.key} />
                ))}
              </Tabs>
            </div>
            :
            <div style={{ height: 10, backgroundColor: '#f5f5f5' }}>&nbsp;</div>
        }

        <div className='tabs-content'>
          <div className='m-b-sm act-dt-tab-1' style={{ margin: 10 }}>
            <div id={`act-dt-tab-1`}></div>
            <div className={`tb-content bg-white`}>
              <div style={{ wordBreak: 'break-word' }}>
                <Article list={description} />
              </div>
            </div>
          </div>
          {
            bookingInstructions && (
              <div className='m-b-sm act-dt-tab-2' style={{ margin: 10 }}>
                <div className='tb-title' id={`act-dt-tab-2`}>
                  <span>{intl.get('book_tips').d('预定须知')}</span>
                </div>
                <div className='tb-content' style={{ padding: 0, marginTop: 5 }} >
                  <div className='act-info'>
                    <div style={{ whiteSpace: 'pre-wrap' }}>{bookingInstructions}</div>
                  </div>
                </div>
              </div>
            )
          }
          {
            notes && (
              <div className='m-b-sm act-dt-tab-3' style={{ margin: 10 }}>
                <div className='tb-title' id={`act-dt-tab-3`}>
                  <span>{intl.get('notice_item').d('注意事项')}</span>
                </div>
                <div className='tb-content' style={{ padding: 0, marginTop: 5 }} >
                  <div className='act-info'>
                    <div style={{ whiteSpace: 'pre-wrap' }}>{notes}</div>
                  </div>
                </div>
              </div>
            )
          }
          <br />

        </div>
      </div>
      <div style={{ height: 60 }}></div>
      {
        !isReadOnly && (
          <div className='act-detail-footer jm-flex'>
            <div className='act-price jm-flex-item'>
              <div className='jm-flex'>
                <div className='act-cart-icon'
                  onClick={() => {
                    if (totalQuantity === 0) return
                    setDetailFlag(true)
                  }}>
                  <CartIcon color="var(--adm-color-primary)" width={25} height={25} />
                  {
                    totalQuantity > 0 && (<span className="act-cart-badge">{totalQuantity}</span>)
                  }
                </div>
                <div>
                  {
                    totalQuantity > 0
                      ?
                      <div>
                        <b className='jm-price fs-18'>
                          <CurrencySymbol currency={currency || detail.currencyCode} />{formatNumber(totalPrice)}
                        </b>
                      </div>
                      :
                      <b className='jm-price fs-18'>0</b>
                  }
                </div>

              </div>

            </div>
            <div>
              <Button
                size='small'
                className='btn-primary'
                style={{ borderRadius: '20px 0 0 20px', backgroundColor: 'var(--adm-color-primary-hover)', padding: '8px 16px' }}
                onClick={() => {
                  setActionFlag(1)
                  setAttrVisible(true)
                }}>
                {intl.get('addToCart').d('加入购物车')}
              </Button>
            </div>
            <div>
              <Button
                size='small'
                className='btn-primary'
                style={{ borderRadius: '0 20px 20px 0', padding: '8px 16px' }}
                onClick={() => {
                  if (curProduct) {
                    setBookFormVisible(true)
                  } else {
                    setActionFlag(2)
                    setAttrVisible(true)
                  }

                  addBehaviorsRecord({
                    behaviorType: 160200,
                    behavior: 160216,
                    storeId: merchantInfo.storeId,
                    value1: 'activity页'
                  })
                }}>
                {intl.get('confirmOrdering').d('Place Order')}
              </Button>
            </div>

          </div>
        )
      }

      <Popup
        visible={bookFormVisible}
        onClose={() => { setBookFormVisible(false) }}
        destroyOnClose>
        <PopupContent resizeFlag={true}>
          <BookForm
            item={{ ...curProduct, quantity: totalQuantity } || detail}
            cartItems={cartItems}
            callback={() => { setBookFormVisible(false) }}
            nextAction={() => { setBookFormVisible(false) }} />
        </PopupContent>
      </Popup>
      {/* 属性选择弹窗 */}
      {detail !== null && attrVisible && (
        <CenterPopup
          className='product-detail-modal'
          visible={attrVisible}
          width={window.innerWidth}
          closeOnMaskClick
          onClose={() => setAttrVisible(false)}
          onMaskClick={() => setAttrVisible(false)}
          bodyStyle={{
            backgroundColor: 'transparent',
            padding: 0
          }}
          style={{
            '--z-index': 1999
          }}
        >
          <RelateAttrModal
            product={detail}
            showIntro={false}
            showStepper={true}
            addToCart={(data) => {
              // console.log(data, '////=====////data///===')
              setCurProduct(data)
              addToCart(data)
              setAttrVisible(false)
              if (actionFlag === 2) {
                setBookFormVisible(true)
              }
            }}
            onCallback={() => {
              // setCurrentItem(null)
              setAttrVisible(false)
              dispatch(resetCart())
            }}
            buttonText={actionFlag === 2 ? intl.get('confirmOrdering').d('Place Order') : null}
          />
        </CenterPopup>
      )}
      {
        detailFlag && cartItems.length > 0 && (
          <Popup
            visible={detailFlag}
            onClose={() => { setDetailFlag(false) }}
            showCloseButton
            onMaskClick={() => { setDetailFlag(false) }}
            destroyOnClose>


            <div className='cart-popup'>
              <div className="cart-panel">
                <div className='cart-title'>{intl.get('cart').d('购物车')}</div>
                <div className='cart-item-list'>
                  {cartItems.map((item, index) => {
                    return (
                      <div key={index} className="cart-item">
                        <div className='jm-flex-item'>
                          {item.productName || detail.name}
                          <div>
                            <AttrString product={item} />
                          </div>
                        </div>
                        <div>
                          <NumStepper
                            max={item.orderMaxNum || (item.stock === -1 ? 99 : item.stock)}
                            items={cartItems}
                            onAdd={(item) => addToCart(item, true)}
                            onRemove={(productId, value) => {
                              removeFromCart(productId, value, item)
                              if (value === 1) {
                                if (cartItems.length === 1) {
                                  setDetailFlag(false)
                                  setCurProduct(null)
                                }
                              }

                            }}
                            curProduct={item}
                          />
                        </div>

                        <div style={{ width: '20%' }}>
                          <div className='jm-price' style={{ padding: '0 10px', textAlign: 'right' }}>
                            <PriceText product={item} from='cart' />
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
                <div className="cart-footer">
                  <b>
                    {intl.get('total').d('合计')}:
                    <span className='jm-price'><CurrencySymbol currency={currency || detail.currencyCode} />{formatNumber(totalPrice)}</span>
                  </b>
                  <Button
                    size='small'
                    className="checkout-button"
                    onClick={() => {
                      setBookFormVisible(true)
                    }}>
                    {intl.get('confirmOrdering').d('Place Order')}
                    ({totalQuantity})
                  </Button>
                </div>
              </div>
            </div>

          </Popup>
        )
      }
    </div>
  )
}

export default ActivityDetail
